/**
 * Text
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="text"></div>
 */
$(function () {
  $('[data-component="text"]').each(function () {
    let $holder = $(this);
    let $more = $('.js-read-more', $holder);

    if ($more.length) {
      $more.click(function (e) {
        e.preventDefault();
        $(this).slideUp();
        $(this).prev().slideDown();
      });
    }
  });
});